// extracted by mini-css-extract-plugin
export var closeButton = "_2h-3";
export var header = "_2h-0";
export var link = "_2h-1";
export var retryButton = "_2h-2";